module.exports = __webpack_public_path__ + "img/cooperation14.aa121159.png";